<template>
  <div class="player-container">
    <video
      :id="id"
      class="vjs-big-play-centered video-js vjs-default-skin vjs-fill"
      controls
      preload="none"
      height="100%"
      width="100%"
    />
  </div>
</template>

<script>
import Utils from "@/utils.js";
import VideoPlayer from "@/helpers/video-player";

const mime = require("mime");

export default {
  data() {
    return {
      player: null
    };
  },
  props: {
    id: {
      type: String,
      required: true
    },
    src: {
      type: String,
      required: true
    },
    poster: {
      type: String,
      default: "",
      required: false
    },
    autoplay: {
      type: Boolean,
      default: false,
      required: false
    },
    disabled: {
      type: Boolean,
      default: false,
      required: false
    },
    mute: {
      type: Boolean,
      default: false,
      required: false
    },
    width: {
      type: Number,
      default: 370,
      required: false
    },
    height: {
      type: Number,
      default: 250,
      required: false
    },
    frameControl: {
      type: Boolean,
      default: false,
      required: false
    },
    elementId:{
      type: String,
      default:'',
      required:false
    }
  },
  computed: {
    isYoutubeVideo() {
      return Utils.validateYouTubeUrl(this.src);
    },
    isVimeoVideo() {
      return /^(https?:)?\/\/((player|www)\.)?vimeo\.com(?=$|\/)/.test(
        this.src
      );
    },
    videoType() {
      if (this.src) {
        if (this.isYoutubeVideo) return "video/youtube";
        else if (this.isVimeoVideo) return "video/vimeo";
        else return mime.getType(this.src);
      }
    },
    techOrder() {
      if (this.src) {
        if (this.isYoutubeVideo) return ["youtube", "Html5"];
        else if (this.isVimeoVideo) return ["vimeo"];
        else return ["Html5"];
      }
    }
  },
  mounted() {
    this.initializeVideoPlayer();
  },
  watch: {
    disabled(v) {
      if (this.player) {
        this.reset();
        if (v) {
          this.player.bigPlayButton.disable();
          this.player.posterImage.disable();
        } else {
          this.player.bigPlayButton.enable();
          this.player.posterImage.enable();
        }
      }
    },
    src(v) {
      if (this.player) {
        this.player.src(v);
      }
    },
    poster(v) {
      if (this.player) {
        this.player.poster(v);
      }
    },
    mute(v) {
      if (this.player) {
        this.player.muted(v);
      }
    }
  },
  methods: {
    enable() {
      this.player.bigPlayButton.enable();
      this.player.posterImage.enable();
    },
    reset() {
      if (this.isYoutubeVideo) {
        this.player.tech().ytPlayer.stopVideo();
      } else if (this.isVimeoVideo) {
        this.player.pause();
      } else {
        this.player.pause();
        this.player.reset();
        this.player.resetControlBarUI_();
        this.player.options_.techOrder = ["Html5"];

        this.player.src(this.src);
        this.player.poster(this.poster);
      }

      this.playerMounted();
    },
    getPlayer() {
      return this.player;
    },
    initializeVideoPlayer() {
      console.log("Init player with config", {
        src: {
          type: this.videoType || "",
          src: this.src
        },
        techOrder: this.techOrder,
        poster: this.poster
      });

      this.player = VideoPlayer.config(this.$el.children[0], {
        src: {
          type: this.videoType || "",
          src: this.src
        },
        techOrder: this.techOrder,
        poster: this.poster
      });

      this.player.on("pause", () => {this.$emit("pause", this.player,this.src,this.elementId)});
      this.player.on("play", () => {this.$emit("play", this.player,this.src,this.elementId)});

      this.$emit("mounted", this.player);
      this.playerMounted();
    },
    playerMounted() {
      if (this.disabled) {
        this.player.bigPlayButton.disable();
        this.player.posterImage.disable();
      }
      this.player.muted(this.mute);
    },
    pause() {
      this.player.pause();
    }
  }
};
</script>

<style lang="scss">
.player-container {
  width: 100%;
  height: 65vw;
}

@media (min-width: 768px) {
  .player-container {
    width: 100%;
    height: 40vw;
  }
}
@media (min-width: 1024px) {
  .player-container {
    width: 100%;
    height: 25vw;
  }
}
.video-js .vjs-control {
  width: 2.5em;
}
.vjs-subs-caps-button {
  display: none;
}
.video-js .vjs-time-control {
    display: block;
}
.video-js .vjs-remaining-time {
    display: none;
}
.vjs-picture-in-picture-control {
  display: none !important;
}
.vjs-time-divider {
  padding: 0 !important;
  min-width: auto !important;
}
.vjs-current-time {
  padding: 0px !important;
}
.vjs-duration {
  padding: 0px !important;
}
</style>
